import React, {useEffect} from 'react'
import searchicon from '../../../../../_metronic/images/hd_searchsearch_blue.svg'
import _ from 'lodash'
export default function ExistingCustomerInfo({
  formik,
  hasFieldError,
  getCustomerByPhoneNumber,
  customerData,
  customer,
  searchText,
  setSearchText,
  isCommercialCustomer,
  makeManualBlur,
  validateNumber,
  setIsCommercialCustomer,
  setIsServiceSameAsBill,
}: any) {
  useEffect(() => {
    if (customerData !== undefined) {
      formik.setFieldValue('customerFirstName', customerData?.getCustomerByUanOrPhone?.firstName)
      formik.setFieldValue('id', customerData?.getCustomerByUanOrPhone?.id)
      if (Boolean(customerData?.getCustomerByUanOrPhone.businessName)) {
        formik.setFieldValue('businessName', customerData?.getCustomerByUanOrPhone.businessName)
        setIsCommercialCustomer(true)
      }
      formik.setFieldValue('customerLastName', customerData?.getCustomerByUanOrPhone.lastName)
      formik.setFieldValue('customerEmailId', customerData?.getCustomerByUanOrPhone.emailId)
      formik.setFieldValue(
        'customerPrimaryPhoneNumber',
        customerData?.getCustomerByUanOrPhone.primaryPhoneNumber
      )
      formik.setFieldValue(
        'customerPhoneNumber',
        customerData?.getCustomerByUanOrPhone.mobileNumber
      )
      formik.setFieldValue('customerType', customerData?.getCustomerByUanOrPhone.customerType.name)
      formik.setFieldValue('customerTypeId', customerData?.getCustomerByUanOrPhone.customerType.id)
      formik.setFieldValue('serviceAddress', customerData?.getCustomerByUanOrPhone.serviceAddress1)
      formik.setFieldValue('serviceAddress2', customerData?.getCustomerByUanOrPhone.serviceAddress2)
      formik.setFieldValue('serviceCountry', customerData?.getCustomerByUanOrPhone.serviceCountry)
      formik.setFieldValue('serviceState', customerData?.getCustomerByUanOrPhone.serviceState)
      formik.setFieldValue('serviceCity', customerData?.getCustomerByUanOrPhone.serviceCity)
      formik.setFieldValue('serviceZipCode', customerData?.getCustomerByUanOrPhone.serviceZipCode)
      if (
        !Boolean(customerData?.getCustomerByUanOrPhone.serviceAddress1) &&
        customerData?.getCustomerByUanOrPhone.billingAddress1 ===
          customerData?.getCustomerByUanOrPhone.serviceAddress1 &&
        customerData?.getCustomerByUanOrPhone.billingAddress2 ===
          customerData?.getCustomerByUanOrPhone.serviceAddress2
      ) {
        setIsServiceSameAsBill(true)
      }
      formik.setFieldValue('billingAddress', customerData?.getCustomerByUanOrPhone.billingAddress1)
      formik.setFieldValue('billingAddress2', customerData?.getCustomerByUanOrPhone.billingAddress2)
      formik.setFieldValue('billingCountry', customerData?.getCustomerByUanOrPhone.billingCountry)
      formik.setFieldValue('billingState', customerData?.getCustomerByUanOrPhone.billingState)
      formik.setFieldValue('billingCity', customerData?.getCustomerByUanOrPhone.billingCity)
      formik.setFieldValue('billingZipCode', customerData?.getCustomerByUanOrPhone.billingZipCode)
      formik.setFieldTouched('customerEmailId', true)

      //even we set values in formik for these above fields, while clicking continue we get field is required error, so we are making manual blur
      setTimeout(() => makeManualBlur(), 1)
    }
  }, [customerData])
  const handleSearch = (searchValue: any) => {
    getCustomerByPhoneNumber({variables: {uanOrPhoneNumber: searchValue}})
  }
  const debouncedFn = _.debounce(handleSearch, 800)
  const onSearchChange = (value: any) => {
    setSearchText(value)
    if (value !== '') {
      debouncedFn(value)
    }
  }
  return (
    <>
      <label className='d-flex align-items-center mb-2 mt-3'>
        <span className='fs-6 fw-semibold text-gray-700 lh-23'>Search by UAN or Phone Number</span>
      </label>
      <div className='d-flex align-items-center position-relative my-1'>
        <input
          type='text'
          data-kt-ecommerce-order-filter='search'
          className='form-control form-control-solid pe-14 input-placeholder-gray-400'
          placeholder='Search by UAN or Phone Number'
          value={searchText}
          onChange={(e: any) => {
            onSearchChange(e.target.value)
          }}
        />
        <span className='svg-icon svg-icon-1 position-absolute me-4' style={{right: 0}}>
          <img src={searchicon} alt='search' />
        </span>
      </div>
      {searchText !== '' && !customerData && <div className='text-danger'>{customer}</div>}
      {Boolean(searchText)&&customerData&& <div className='text-success'>Customer found</div>}
    </>
  )
}
